import * as p from "react";
import * as c from "react-dom";
import { c as f } from "./index.B4ZV02se.js";
import { j as u } from "./jsx-runtime.DGlMoOmv.js";
var l = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], h = l.reduce((t, i) => {
  const o = f(`Primitive.${i}`), r = p.forwardRef((e, s) => {
    const { asChild: a, ...m } = e, n = a ? o : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u.jsx(n, { ...m, ref: s });
  });
  return r.displayName = `Primitive.${i}`, { ...t, [i]: r };
}, {});
function w(t, i) {
  t && c.flushSync(() => t.dispatchEvent(i));
}
export {
  h as P,
  w as d
};
//# sourceMappingURL=index.DMLWxr4u.js.map
